var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{staticStyle:{"height":"93vh"},attrs:{"src":_vm.instruction,"width":"100%","allowfullscreen":"","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }